var exports = {
  "D": "UtilityButtons.module__inboxButton___Y1Rsem",
  "K": "UtilityButtons.module__inboxBadge___Y1Rsem",
};

module.exports = exports;
